// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1bahesu3{justify-content:flex-end}
._1e0c1txw{display:flex}
._2hwx1wug{margin-right:auto}
._ca0qpxbi{padding-top:var(--ds-space-200,1pc)}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/link-picker/dist/esm/ui/link-picker/form-footer/index.compiled.css"],"names":[],"mappings":"AAAA,WAAW,wBAAwB;AACnC,WAAW,YAAY;AACvB,WAAW,iBAAiB;AAC5B,WAAW,mCAAmC","sourcesContent":["._1bahesu3{justify-content:flex-end}\n._1e0c1txw{display:flex}\n._2hwx1wug{margin-right:auto}\n._ca0qpxbi{padding-top:var(--ds-space-200,1pc)}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
